<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item
      :name='this.index'
      class="spceial">
      <template
        slot="title"
        class="small">
        <div class="tit-wapper-per-offer">
          <div class="discTitle-offer">
            <span class="zhuanye_name" :title='item.zhuanye_name'>申请流程{{ index+1 }}:{{ item.schoolname }}-{{ item.zhuanye_name }}</span><b class="state">{{ this.zhaungtai }}</b>
            <div class="state-group">
              <el-button
                class="jm-button-white"
                :type="state['0']"
                @click.stop="changeProcess(1)">申请中</el-button>
              <el-button
                class="jm-button-white"
                :type="state['1']"
                @click.stop="changeProcess(2)">终止流程</el-button>
              <el-button
                class="jm-button-white"
                :type="state['2']"
                @click.stop="changeProcess(3)">入学</el-button>
            </div>
          </div>

        </div>
      </template>
      <el-tabs
        v-model="activeName"
        class="tec-uk">
        <el-tab-pane name="1">
          <div
            slot="label"
            class="is-label-wapper">
            <!--变量动态添加class is-alery-->
            <!--<div class="is-label" :class="item.shenqing_cailiao === '' || item.shenqing_cailiao === 0 ? '':'is-alery'">-->
            <div
              class="is-label"
              :class="showalery(item.shenqing_cailiao)">
              <i>1</i>
            </div>
            <span>申请材料</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">申请材料</label>
            <jm-dict-select
              clearable
              v-model="item.shenqing_cailiao"
              type="online"
              dict-type="shenqing_cailiao" />
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">代理方式（*）</label>
            <jm-dict-select
              clearable
              :disabled="!$hasPermission([123])"
              v-model="item.daili"
              type="online"
              dict-type="uk_daili" />
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">递交代理</label>
            <jm-dict-select
              clearable
              v-model="item.send_daili"
              type="dataset"
              dict-type="student"
              name="hasdijiao"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">申请费用</label>
            <jm-dict-select
              clearable
              v-model="item.uk_applyfee"
              type="online"
              dict-type="uk_applyfee" />
          </div>
          <div class="box-content-details-all">
            <label class="form-tit-detial-text">填写费用的具体金额</label>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2}"
              placeholder="请输入内容"
              v-model="item.applyfee_tell"/>
          </div>
          <div class="box">
            <label class="form-tit-detial">递交校方（*）</label>
            <jm-dict-select
              clearable
              v-model="item.submit_school"
              type="dataset"
              dict-type="student"
              name="hasdijiao"/>
            <label class="form-tit-detial inline">递交时间（*）</label>
            <el-date-picker
              v-model="item.submit_school_end"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"/>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2">
          <div
            slot="label"
            class="is-label-wapper">
            <div
              class="is-label"
              :class="showalery(item.mianshi)">
              <i>2</i>
            </div>
            <span>面试</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">面试</label>
            <jm-dict-select
              clearable
              v-model="item.mianshi"
              type="online"
              dict-type="mianshi" />
          </div>
        </el-tab-pane>
        <el-tab-pane name="3">
          <div
            slot="label"
            class="is-label-wapper">
            <div
              class="is-label"
              :class="showalery(item.offer_xiafa)">
              <i>3</i>
            </div>
            <span>申请结果</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial-line">申请结果</label>
            <jm-dict-select
              id="haslong"
              style="width: 250px"
              clearable
              v-model="item.offer_xiafa"
              type="online"
              dict-type="offer_xiafa" />
            <label class="form-tit-detial-line">申请结果时间（*）</label>
            <!--同submit_school_end规则-->
            <el-date-picker
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="item.submit_school_jieguodate"
              type="date"
              placeholder="选择日期"/>
            <el-button
              :disabled="showMesageData['offer_xiafa'].indexOf(`${item.offer_xiafa}`) !== -1 || item.offer_xiafa === ''"
              type="primary"
              plain
              @click="showMessage('申请结果',item.offer_xiafa,'online','offer_xiafa', '', 'offer_xiafa')"
              v-if="showMesageData!== null">
              <span>短信（{{ showMesageData['offer_xiafa'].indexOf(`${item.offer_xiafa}`) !== -1 || item.offer_xiafa === ''? 0: 1 }}）</span>
            </el-button>
          </div>
          <!--uk30 aus31-->
          <jm-materialClouds
            :title="'上传offer或拒信'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'offer_xiafa',
            }"
            :qufen="this.item.id"
            @cloudDataEmptyFlag=getCloudDataEmptyFlag
          />
          <el-button
            class="bianji"
            type="primary"
            @click="getshowOfferpic('offer_xiafa','',item.offer_school_id)">编辑offer</el-button>
          <el-button
            class="bianji"
            type="primary"
            @click="getOfferpic('offer_xiafa','',item.offer_school_id)">预览offer</el-button>
          <el-button
            class="bianji"
            type="primary"
            @click="getshowOfferpic('offer_xiafa','推广',item.offer_school_id)">编辑推广图片</el-button>
          <el-button
            class="bianji"
            type="primary"
            @click="getOfferpic('offer_xiafa','推广',item.offer_school_id)">预览推广图片</el-button>
          <div class="box-content-details">
            <label class="form-tit-detial-text">老师添加补充材料的备注/Offer要求的备注/被调剂专业等备注</label>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="item.shenqing_result_tell"/>
          </div>
          <div class="box-content-details-longer">
            <div class="box-content-details">
              <label class="form-tit-detial">接受Offer截止日</label>
              <el-date-picker
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="item.get_offer_date"
                type="date"
                placeholder="选择日期"/>
            </div>
            <el-button
              :disabled="showMesageData['get_offer_date'].length > 0 || item.get_offer_date === null"
              type="primary"
              plain
              @click="showMessageData('接受Offer截止日',`${item.get_offer_date}`, item.get_offer_date, 'get_offer_date')"
              v-if="showMesageData!== null">
              <span>短信（{{ showMesageData['get_offer_date'].length > 0 || item.get_offer_date === null? 0: 1 }}）</span>
            </el-button>
          </div>
          <div class="box-content-details-longer">
            <div class="box-content-details">
              <label class="form-tit-detial">学生接受Offer日</label>
              <el-date-picker
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="item.student_get_offer_date"
                type="date"
                placeholder="选择日期"/>
            </div>
            <span class="offer-state">Offer接受状态：<jm-dict-select
              :show="true"
              type="dataset"
              v-model="item.is_get_offer"
              dict-type="student"
              name="getOffer"/></span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">正课押金金额</label>
            <jm-dict-select
              clearable
              v-model="item.main_subject_money"
              type="online"
              dict-type="main_subject_money" />
          </div>
          <div
            class="box-content-details"
            v-if="item.main_subject_money === 659">
            <label class="form-tit-detial-text">正课押金金额备注</label>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="item.main_subject_tell"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">正课押金截止日</label>
            <jm-dict-select
              clearable
              type="dataset"
              v-model="item.main_subject_money_date_end_is"
              dict-type="student"
              name="customPurpose"/>
            <!--正课押金截止日日期-->
            <div
              style="display: inline-block"
              v-show="item.main_subject_money_date_end_is === 2">
              <label class="form-tit-detial-line">正课押金截止日日期</label>
              <el-date-picker
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="item.main_subject_money_date_end"
                type="date"
                placeholder="选择日期"/>
              <el-button
                :disabled="showMesageData['main_subject_money_date_end'].length > 0 || item.main_subject_money_date_end === null"
                type="primary"
                plain
                @click="showMessageData('正课押金截止日日期',`${item.main_subject_money_date_end}`, item.main_subject_money_date_end, 'main_subject_money_date_end')"
                v-if="showMesageData!== null">
                <span>短信（{{ showMesageData['main_subject_money_date_end'].length > 0 || item.main_subject_money_date_end === null? 0: 1 }}）</span>
              </el-button>
            </div>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">正课押金支付日</label>
            <el-date-picker
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="item.main_subject_money_date_start"
              type="date"
              placeholder="选择日期"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">正课押金支付方式</label>
            <jm-dict-select
              clearable
              v-model="item.main_subject_money_pay"
              type="online"
              dict-type="main_subject_money_pay" />
          </div>
          <jm-materialClouds
            :title="'查看学生上传证明'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :qufen="this.item.id"
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'main_subject_money',
          }"/>
          <div class="box-content-details">
            <label class="form-tit-detial">奖学金（*）</label>
            <jm-dict-select
              clearable
              type="dataset"
              v-model="item.scholarship"
              dict-type="student"
              name="customPurpose"/>
          </div>
          <div
            class="box-content-details-all"
            v-show="item.scholarship === 2">
            <label class="form-tit-detial">奖学金</label>
            <el-input
              style="width:200px"
              placeholder="请输入内容"
              v-model="item.award"/>
            <span style="color:red"> 填写范例：$5000/年</span>
          </div>
          <div
            class="box-content-details-all"
            v-show="item.scholarship === 2">
            <label class="form-tit-detial-text">奖学金备注</label>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2}"
              placeholder="请输入内容"
              v-model="item.scholarship_tell"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">ATAS</label>
            <jm-dict-select
              clearable
              type="dataset"
              v-model="item.atas"
              dict-type="student"
              name="customPurpose"/>
            <label
              v-show="item.atas === 2"
              class="form-tit-detial-special">ATAS日期</label>
            <el-date-picker
              v-show="item.atas === 2"
              v-model="item.atas_date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">延期Offer</label>
            <jm-dict-select
              clearable
              v-model="item.yanqi"
              type="online"
              dict-type="yanqi" />
          </div>
          <jm-materialClouds
            :title="'上传延期Offer'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'yanqi',
            }"
            :qufen="this.item.id"/>
          <div class="box-content-details-longer">
            <div class="box-content-details">
              <label class="form-tit-detial">延期Offer截止日</label>
              <el-date-picker
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="item.get_yanqi_offer_date"
                type="date"
                placeholder="选择日期"/>
            </div>
            <el-button
              :disabled="showMesageData['get_yanqi_offer_date'].length > 0 || item.get_yanqi_offer_date === null"
              type="primary"
              plain
              @click="showMessageData('延期Offer截止日',`${item.get_yanqi_offer_date}`, item.get_yanqi_offer_date, 'get_yanqi_offer_date')"
              v-if="showMesageData!== null">
              <span>短信（{{ showMesageData['get_yanqi_offer_date'].length > 0 || item.get_yanqi_offer_date === null? 0: 1 }}）</span>
            </el-button>
          </div>
          <div class="box-content-details-longer">
            <div class="box-content-details">
              <label class="form-tit-detial">延期Offer学生接受日</label>
              <el-date-picker
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="item.student_get_yanqi_offer_date"
                type="date"
                placeholder="选择日期"/>
            </div>
            <span class="offer-state">延期Offer接受状态：<jm-dict-select
              :show="true"
              type="dataset"
              v-model="item.is_get_yanqi_offer"
              dict-type="student"
              name="getOffer"/></span>
          </div>
        </el-tab-pane>
        <el-tab-pane name="4">
          <div
            slot="label"
            class="is-label-wapper">
            <div
              class="is-label"
              :class="showalery(item.lange)">
              <i>4</i>
            </div>
            <span>语言申请</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial-line">语言申请</label>
            <jm-dict-select
              clearable
              v-model="item.lange"
              type="online"
              dict-type="lange" />
            <label class="form-tit-detial-line">语言时长</label>
            <jm-dict-select
              clearable
              type="dataset"
              v-model="item.lange_week"
              dict-type="student"
              name="langeWeek"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial-text">语言申请备注（*）</label>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="item.lange_tell"/>
          </div>
          <div class="box">
            <label class="form-tit-detial-line">语言Offer</label>
            <jm-dict-select
              clearable
              v-model="item.lange_offer"
              type="online"
              dict-type="lange_offer" />
            <label class="form-tit-detial-line">语言费用要求</label>
            <jm-dict-select
              clearable
              v-model="item.lange_pay"
              type="online"
              dict-type="lange_pay" />
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial-text">填写金额备注</label>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="item.lange_pay_tell"/>
          </div>
          <jm-materialClouds
            :title="'上传语言Offer'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'lange_offer',
            }"
            :qufen="this.item.id"/>
          <div class="box-content-details">
            <label class="form-tit-detial-line">语言押金截止日</label>
            <jm-dict-select
              clearable
              type="dataset"
              v-model="item.lange_pay_date_end_is"
              dict-type="student"
              name="customPurpose"/>
            <label class="form-tit-detial-line">语言押金截止日期</label>
            <el-date-picker
              v-model="item.lange_pay_date_end"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"/>
            <el-button
              :disabled="showMesageData['lange_pay_date_end'].length > 0 || item.lange_pay_date_end === null"
              type="primary"
              plain
              @click="showMessageData('语言押金截止日期',`${item.lange_pay_date_end}`, item.lange_pay_date_end, 'lange_pay_date_end')"
              v-if="showMesageData!== null">
              <span>短信（{{ showMesageData['lange_pay_date_end'].length > 0 || item.lange_pay_date_end === null? 0: 1 }}）</span>
            </el-button>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">语言押金支付日</label>
            <el-date-picker
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="item.lange_pay_sell_date"
              type="date"
              placeholder="选择日期"/>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">语言押金支付方式</label>
            <jm-dict-select
              clearable
              v-model="item.lange_pay_sell_type"
              type="online"
              dict-type="main_subject_money_pay" />
          </div>
          <jm-materialClouds
            :title="'查看学生上传证明'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'lange_pay_sell',
            }"
            :qufen="this.item.id"/>
        </el-tab-pane>
        <el-tab-pane name="5">
          <div
            slot="label"
            class="is-label-wapper">
            <div
              class="is-label"
              :class="showalery(item.lange_cas)">
              <i>5</i>
            </div>
            <span>语言CAS</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">语言CAS</label>
            <jm-dict-select
              clearable
              v-model="item.lange_cas"
              type="online"
              dict-type="lange_cas" />
            <label style="padding: 0 6px">语言学费</label>
            <el-input
              style="width: 200px"
              v-model.number="item.lange_cas_tuition"
              type="number"
              placeholder="单位：英镑，只需填写数字"/>
            <label style="padding: 0 6px">语言开课时间</label>
            <el-date-picker
              v-model="item.lange_cas_start_time"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"/>
          </div>
          <jm-materialClouds
            :title="'上传语言CAS'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :qufen="this.item.id"
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'lange_cas',
          }"/>
        </el-tab-pane>
        <el-tab-pane name="6">
          <div
            slot="label"
            class="is-label-wapper">
            <div
              class="is-label"
              :class="showalery(item.un_con)">
              <i>6</i>
            </div>
            <span>Uncon-offer</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">Uncon-Offer</label>
            <jm-dict-select
              clearable
              v-model="item.un_con"
              type="online"
              dict-type="un_con" />
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial-text">被拒原因</label>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="item.un_con_fail"/>
          </div>
          <jm-materialClouds
            :title="'上传Uncon-Offer'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :qufen="this.item.id"
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'un_con',
          }"/>
        </el-tab-pane>
        <el-tab-pane name="7">
          <div
            slot="label"
            class="is-label-wapper">
            <div
              class="is-label"
              :class="showalery(item.class_cas)">
              <i>7</i>
            </div>
            <span>正课CAS</span>
          </div>
          <div class="box-content-details">
            <label class="form-tit-detial">正课CAS</label>
            <jm-dict-select
              clearable
              v-model="item.class_cas"
              type="online"
              dict-type="class_cas" />
            <label style="padding: 0 6px">正课学费</label>
            <el-input
              style="width: 200px"
              v-model.number="item.class_cas_tuition"
              type="number"
              placeholder="单位：英镑，只需填写数字"/>
            <label style="padding: 0 6px">正课开课时间</label>
            <el-date-picker
              v-model="item.class_cas_start_time"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"/>
          </div>
          <jm-materialClouds
            :title="'上传正课CAS'"
            upload-url='/newfib.php/index/base_process/fileuploadOfferSchool'
            :qufen="this.item.id"
            :upload-data="{
              crm_id: this.$route.params.crm_id,
              offer_school_id:this.item.id,
              country_id:30,
              field_name:'class_cas',
          }"/>
        </el-tab-pane>
      </el-tabs>
      <slot name="btnGroup"/>
    </el-collapse-item>
    <!--短信-->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span v-if="!isData">
        你的{{ item.schoolname }}的{{ item.zhuanye_name }}专业，已获得:{{ this.showMessageTiele }}
        <jm-dict-select
          :show="true"
          v-model="showMessageModel"
          :type="showMessageType"
          :dict-type="showMessageDictType"
          :name="showMessageName" />
      </span>
      <span v-if="isData">
        你的{{ item.schoolname }}的{{ item.zhuanye_name }}专业的{{ this.showMessageDataTitle }}为:{{ this.showMessageDatanum }}
      </span>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="sendShort()">确 定</el-button>
      </span>
    </el-dialog>
    <!--编辑canvas-->
    <el-dialog
      class="tuya"
      title="编辑offer图片"
      :visible.sync="dialogVisibleBianji"
      :fullscreen='true'
    >
      <div class="bianji-offer">
        <jm-tuya
          :back-url="imgUrl"
          :offer-school-id="this.item.offer_school_id"
          :ext = "this.ext"
          :id-num = 'this.index'
          country-id="30"
          :id="pdfId"
          @childchange="ichange"
          field-name="offer_xiafa"/>
      </div>
      <span
        slot="footer"
        class="tuya-dialog-footer">
        <el-button @click="dialogVisibleBianji = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!--预览编辑完成图片-->
    <el-dialog
      title="水印offer图片"
      :visible.sync="centerDialogVisible"
      width="500px"
      center>
      <img
        class="lastImg"
        :src="watermark" >
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-collapse>
</template>
<script>
import { jmDictSelect, jmUploadFile } from '@/components/tool';
import materialClouds from '@/pages/student/officials/materialClouds.vue';
import tuya from '@/pages/student/officials/tuya.vue';

export default {
  data() {
    return {
      activeNames: [],
      activeName: '1',
      zhaungtai: '',
      dialogVisible: false,
      imageUrl: '',
      options: [{
        value: '1',
        label: '已递交'
      }],
      state: [null, null, null],
      showMessageTiele: null,
      showMessageModel: null,
      showMessageType: null,
      showMessageDictType: null,
      showMessageName: null,
      dialogVisibleBianji: false,
      showMesageData: null,
      sendName: null,
      sendstatus: null,
      isData: null,
      showMessageDataTitle: null,
      showMessageDatanum: null,
      allData: {
        scores: {}
      },
      imgUrl: null,
      pdfId: null,
      watermark: null,
      centerDialogVisible: false,
      ext: null,
    };
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: null
    },
    ScoreData: {
      type: Object,
      default: null
    },
    thisNum: {
      type: Number,
      default: null
    }
  },
  methods: {
    onlyNum(text) {
      console.log(text);
    },
    showalery(isAlery) {
      // 点亮图标
      if (isAlery) {
        if (isAlery !== '' && isAlery !== 0) {
          return 'is-alery';
        }
      }
      return '';
    },
    ichange(val) {
      this.dialogVisibleBianji = val;
    },
    getshowOfferpic(name, ext, offerId) {
      if (!offerId) {
        this.$message.error('保存之后方可使用此功能');
        return false;
      }
      this.$http._post({
        url: '/index/base_process/getShowEditOfferImg',
        data: {
          crm_id: this.$route.params.crm_id,
          offer_school_id: this.item.id,
          field_name: name,
          country_id: 30,
          ext: ext,
        }
      }).then((data) => {
        if (data.result === -1) {
          this.$message.error(data.msg);
        } else {
          this.imgUrl = data.data.picurl;
          this.ext = ext;
          this.pdfId = data.data.id;
          this.dialogVisibleBianji = true;
        }
      });
    },
    // image2Base64(url) {
    //   let base64 = '';
    //   let img = new Image();
    //   img.src = url;
    //   img.onload = function () {
    //     let canvas = document.createElement('canvas');
    //     canvas.width = img.width;
    //     canvas.height = img.height;
    //     let ctx = canvas.getContext('2d');
    //     ctx.drawImage(img, 0, 0, img.width, img.height);
    //     let dataURL = canvas.toDataURL('image/jpeg');
    //     alert(base64);
    //   };
    //   return base64;
    // },
    getOfferpic(name, ext, offerId) {
      if (!offerId) {
        this.$message.error('保存之后方可使用此功能');
        return false;
      }
      this.$http._post({
        url: '/index/base_process/getEditOfferImg',
        data: {
          crm_id: this.$route.params.crm_id,
          offer_school_id: this.item.offer_school_id ? this.item.offer_school_id : this.item.id,
          country_id: 30,
          field_name: name,
          ext: ext,
        }
      }).then((data) => {
        if (data.data.picurl_watermark) {
          this.watermark = data.data.picurl_watermark;
          this.centerDialogVisible = true;
        }
      });
    },
    showMessage(title, model, type, dictType, name, keys) {
      this.isData = false;
      this.sendName = keys;
      this.sendstatus = model;
      this.showMessageTiele = title;
      this.showMessageModel = model;
      this.showMessageType = type;
      this.showMessageDictType = dictType;
      this.showMessageName = name;
      this.dialogVisible = true;
    },
    showMessageData(name, data, model, keys) {
      this.isData = true;
      this.sendName = keys;
      this.sendstatus = model;
      this.showMessageDataTitle = name;
      this.showMessageDatanum = data;
      this.dialogVisible = true;
    },
    changeProcess(num) {
      if (!this.item.offer_school_id) {
        this.$message.error('保存之后才可编辑状态');
        return false;
      }
      this.$confirm('此操作将改变申请流程状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.item.is_t_over = num;
        this.$http._post({
          url: '/index/base_process/changeProcess',
          data: {
            is_t_over: this.item.is_t_over,
            offer_school_id: this.item.offer_school_id,
            country_id: this.item.country_cure
          }
        }).then((data) => {
          if (data) {
            this.checkstate();
          }
        }).catch(() => {
          this.$message.error('服务端失败');
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    getShort() {
      this.$http._post({
        url: '/index/uk_process/getMessageAmount',
        data: {
          crm_id: this.$route.params.crm_id,
          offer_school_id: this.item.offer_school_id,
        }
      }).then((data) => {
        this.showMesageData = data.data;
      });
    },
    sendShort() {
      this.$http._post({
        url: '/index/uk_process/sendMessage',
        data: {
          crm_id: this.$route.params.crm_id,
          offer_school_id: this.item.offer_school_id,
          filed_name: this.sendName,
          status_v: this.sendstatus
        }
      }).then(() => {
        this.getShort();
        this.$message.success('发送成功');
        this.dialogVisible = false;
      });
    },
    checkstate() {
      if (this.item.is_t_over === 1) {
        this.zhaungtai = '申请中';
      } else if (this.item.is_t_over === 2) {
        this.zhaungtai = '终止流程';
      } else if (this.item.is_t_over === 3) {
        this.zhaungtai = '入学';
      }
      this.state.forEach((itemA, index) => {
        if (index === (this.item.is_t_over - 1)) {
          this.state[index] = 'success';
        } else {
          this.state[index] = 'primary';
        }
      });
    },
    getCloudDataEmptyFlag(flag) {
      this.item.cloudDataEmptyFlag = flag;
    },
  },
  watch: {
    item: {
      handler: function (val) {
        this.item.ischange = true;
        this.item.thisIndex = this.index;
        this.$emit('childData', val);
      },
      deep: true
    },
  },
  components: {
    jmDictSelect,
    jmUploadFile,
    'jm-materialClouds': materialClouds,
    'jm-tuya': tuya
  },
  mounted() {
    this.item.ischange = false;
    this.item.thisIndex = this.index;
    this.$emit('childData', this.item);
    if (this.$route.params.num >= 0) {
      this.activeNames.push(this.$route.params.num);
    }
    if (this.item.is_t_over) {
      this.checkstate();
    } else {
      this.zhaungtai = '未开始';
    }
    this.getShort();
    if (this.item.shenqingdate > '2010-01-01' && this.item.submit_school_end < '2010-01-01') {
      this.item.submit_school_end = this.item.shenqingdate;
    }
    if (this.item.jieguodate > '2010-01-01' && this.item.submit_school_jieguodate < '2010-01-01') {
      this.item.submit_school_end = this.item.jieguodate;
    }
  }
};
</script>
<style scoped>
  .form-tit-detial-text{
    display: block;
    margin-bottom: 4px;
  }
  .form-tit-detial-special{
    margin-left: 6px;
  }
  .form-tit-detial-line{
    margin-right: 6px;
  }
  .lastImg{
    width: 100%;
    border: 1px solid #000;
  }
  .offer-state{
    margin-left: 10px;
  }
  .tuya-dialog-footer{
    display: flex;
    justify-content:center;
  }
  .is-label>i{
    display: inline-block;
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-style: normal;
    font-weight: bold;
    color: #c2cad7;
    border: 2px solid #c2cad7;
    background-color: #fff;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -17px;
    margin-left: -17px;
    overflow: hidden;
    text-align: center;
  }
  .discTitle-offer{
    float: left;
    width: 100%;
  }
   .discTitle-offer span{
    display: inline-block;
  }
  .discTitle-offer .zhuanye_name{
    width:43%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
    margin-right: 10px;
  }
  .state-group{
    float: left;
    margin:0 20px;
  }
  .is-ok{
    color:red;
  }
  .form-tit-detial{
    margin-right: 6px;
    white-space: nowrap;
    width: 120px;
    display: inline-block;
  }
  .btn-group button{
    margin-right: 10px;
  }
  .box-content-details,.box-content-details-all{
    margin-bottom: 6px;
  }
  .box{
    margin-bottom: 10px;
    padding-left: 6px;
  }
  .box-content-details-all{
    width: 80%;
  }
  .inline{
    margin-left: 10px;
  }
  .btn-group{
    padding: 10px;
    border: 1px solid #ebeef5;
    border-top: none;
    background: #FBFDFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-group a{
    line-height: 34px;
    display: block;
    float: left;
    height:34px;
    padding: 0 16px;
    font-size: 14px;
    border-radius: 4px;
    color: #409EFF;
    border: 1px solid #409EFF;
    margin-left: 8px;
  }
  .btn-group:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }
  .avatar-uploader-icon {
    position: relative;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .upload-wapper{
    width: 178px;
    height: 178px;
    position: relative;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .has-upload{
    width: 100%;
    height:178px;
    position: absolute;
    left:0;
    top:0;
    background: #d1d6d9;
    opacity:0.8;
    z-index:10;
  }
  .box-content-details2{
    width: 30%;
    margin-bottom: 10px;
    padding-left: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .box-content-details-longer{
    display: flex;
    align-items: center;
  }
  .box-content-details-longer>button{
    margin-bottom: 10px;
  }
  .box-content-details-longer:after{
    display: block;
    clear: both;
    opacity:0;
    content: '';
  }
  .box-content-details-longer>div,.box-content-details-longer>button{
    float: left;
  }
  .box-content-details-longer>button{
    margin-left: 10px;
  }
  .is-label{
    width: 55px;
    height: 55px;
    position: relative;
    margin: 0 auto;
  }
  .el-tabs__nav-scroll .is-active .is-label {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU5MDBBQkJCMzkyRTExRTdBMzI5QTVCMkMzQUIwQTJBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU5MDBBQkJDMzkyRTExRTdBMzI5QTVCMkMzQUIwQTJBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTkwMEFCQjkzOTJFMTFFN0EzMjlBNUIyQzNBQjBBMkEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTkwMEFCQkEzOTJFMTFFN0EzMjlBNUIyQzNBQjBBMkEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5r9FawAAAAr0lEQVR42uzaQQoCMQwF0FQG9FTeXU/lLjLKQBXUjgjV+v5i1nk0A4Gk5GGbsS4l9qfokuNu/q6qdxODZ7p5md9Ia515D4xurdea1vqurfwfLQoICAgICPhikimD2i6ukplaFBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQ8EOZ6pOLrz8jaU1lmtdny3pptDVa+gcBAQEBAU0yDyaAp+l7s/02sPVgpvfE4yi9zlmAAQChXBcJ4NLlJAAAAABJRU5ErkJggg==);
    background-size: contain;
  }
  .is-alery>i{
    width: 53px;
    height: 53px;
    border: none;
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    margin-top: -26.5px;
    margin-left: -26.5px;
    text-indent: 55px;
  }
</style>
<style>
   .technological-wapper input[type=number] {
    -moz-appearance:textfield;
  }
.technological-wapper input[type=number]::-webkit-inner-spin-button,
.technological-wapper input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
  #haslong>div{
    width: 100%;
  }
  .tec-uk .is-label-wapper>span{
    display: block;
    text-align: center;
    font-size: 14px;
  }
  .tit-wapper-per-offer .state{
    color: #333;
    line-height: 58px;
    font-size: 20px;
    height: 100%;
    margin-left: 7%;
    width: 9%;
    display: inline-block;
    float: left;
  }
  .btn-group button{
    float: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .box-content-details2 .el-input{
    width: auto;
  }
  .technological-wapper .el-tabs__item{
    line-height: 26px;
  }
  .technological-wapper .el-tabs__item{
    height: auto;
  }
  /*.technological-wapper .el-tabs__active-bar{*/
  /*visibility: hidden;*/
  /*}*/
  .technological-wapper .el-tabs{
    padding: 10px;
  }
  .technological-wapper .el-tabs__nav #tab-1 .is-alery>i{
    background: url(../../../../assets/images/step1.png);
  }
  .technological-wapper .el-tabs__nav #tab-2 .is-alery>i{
    background: url(../../../../assets/images/step2.png);
  }
  .technological-wapper .el-tabs__nav #tab-3 .is-alery>i{
    background: url(../../../../assets/images/step3.png);
  }
  .technological-wapper .el-tabs__nav #tab-4 .is-alery>i{
    background: url(../../../../assets/images/step4.png);
  }
  .technological-wapper .el-tabs__nav #tab-5 .is-alery>i{
    background: url(../../../../assets/images/step5.png);
  }
  .technological-wapper .el-tabs__nav #tab-6 .is-alery>i{
    background: url(../../../../assets/images/step6.png);
  }
  .technological-wapper .el-tabs__nav #tab-7 .is-alery>i{
    background: url(../../../../assets/images/step7.png);
  }
</style>
